import { API_URL, CUSTOMERS_KEY } from '../keys'
import axios from 'axios'

const BASE_URL = `${API_URL}/products/attributes`

const defaultHeaders = {
	'sce-api-key': CUSTOMERS_KEY,
	'Content-Type': 'application/json',
}

const defaultConfig = {
	headers: defaultHeaders,
	validateStatus: (status: number) => status < 500,
}

export const verifyStockOfAttribute = async (
	productId: string,
	attributeId: string
) => {
	const response = await axios.get(`${BASE_URL}/stock`, {
        ...defaultConfig,
        params : {
            productId,
            attributeId
        }
    })
	if (response) return response
}
